import superagent from 'superagent'

export const assignSubscription = (payload) => (dispatch, getState, token) => {

  let { assignUserId, userSubId } = payload
  let reqBody = { assignUserId, userSubId }

  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/UserSubscription/Assign?assignUserId=${assignUserId}&userSubId=${userSubId}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err)
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
      })
  })
}
